function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgChatPlusi = function SvgChatPlusi(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M11.55 11.548v-3.23a.45.45 0 0 1 .9 0v3.23h3.23a.45.45 0 1 1 0 .9h-3.23v3.23a.45.45 0 0 1-.9 0v-3.23H8.32a.45.45 0 1 1 0-.9z"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChatPlusi);
export default ForwardRef;